import type { createUserGateway } from '@mntn/gary-client'

export interface AppSessionProps {
  currentAdvertiser: {
    id: number
    name: string
  }
}

type GarySessionData = Awaited<ReturnType<ReturnType<typeof createUserGateway>['getSession']>>

export const createAppSession = (garySessionData: GarySessionData) => {
  if (!garySessionData?.current_advertiser) {
    return null
  }

  const { current_advertiser } = garySessionData

  return Object.freeze({
    advertiser: {
      id: current_advertiser.advertiser_id,
      name: current_advertiser.company_name,
      logo: current_advertiser.logo ?? undefined,
    },
  })
}
